import ScrollGradient from './scroll-gradient';

export default ScrollGradient;
